import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const SampleServicesCrud = {
    allServices : async (data) =>{
        return await commonRequest("GET",  `${Helpers.URL()}/api/v2//admin/sample-services/list`, data, Helpers.token());
    },
    updateServiceById: async (id, data) => {
        return await commonRequest("PUT", `${Helpers.URL()}/api/v2/admin/sample-services/updateService/${id}`, data, Helpers.token());
    },
}